const capitalizeFirstLetter = (str) =>
  str ? str[0].toUpperCase() + str.slice(1) : "";

export { capitalizeFirstLetter };
